<script lang="ts" setup>
import Top from '@/components/Top/Top.vue'
import Partnerships from '@/domains/esg/partnerships/components/partnerships/Partnerships.vue'
import Awards from '@/domains/esg/partnerships/components/awards/PartnershipsAwards.vue'
import UiItems from '@/components/UiItem/UiItems.vue'
import { usePartnerships } from '@/domains/esg/composables/content/usePartnerships'

const { t, locale } = useI18n()
const { ratings, awards } = usePartnerships()

useHead({
  title: t('pageTitles.partnerships.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.ourApproach.meta'),
    },
  ],
  link: [
    {
      hid: 'favicon',
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon.ico',
    },
    {
      rel: 'canonical',
      href: t(`pageTitles.partnerships.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.partnerships.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.partnerships.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.partnerships.canonical.pl'),
    },
  ],
})

</script>

<template>
  <div class="partnerships">
    <Top
      :header="$t('partnerships.top.header')"
      :subheader="$t('partnerships.top.subheader')"
    />

    <Partnerships />

    <TextWithImage
      id="ratings"
      class="ratings"
      layout="layout-2"
      :header="$t('partnerships.ratings.header')"
      :text-second="$t('partnerships.ratings.subheader')"
      image="/images/partnerships/partnerships-ratings.png"
    />

    <UiSection
      color="white"
      class="section-ratings"
    >
      <UiItems :items="ratings.items" />
    </UiSection>

    <Awards
      :header="$t('partnerships.awards.header')"
      :subheader="$t('partnerships.awards.subheader')"
      :items="awards"
    />
  </div>
</template>

<style lang="scss" scoped>
.section {
  &-ratings {
    padding-top: 0;
  }
}

:deep(.ui-header__subheader) {
  margin-bottom: 5.6rem;
  @include h10;
}

.ratings {
  :deep(.text-with-image__layout--layout-2) {
    margin-top: 3.2rem;
  }

  :deep(.ui-header__subheader) {
    @include h7;
  }

  :deep(.text-with-image__text--second) {
    @include h9;
    margin-bottom: 0;
  }
}

@include atM {
  :deep(.ui-header__subheader) {
    @include h7;
  }

  .ratings {
    :deep(.text-with-image__layout--layout-2) {
      margin-top: 9rem;
    }

    :deep(.text-with-image__text--second) {
      @include h7;
    }
  }
}
</style>
